import DealStagesFragments from 'features/deals/DealStages/fragments';
import { PoolHeaderFragments } from 'features/loanPool/PoolHeader';
import { StatusTrackerFragments } from 'features/pages/marketplace/StatusTracker';

import { gql } from '@apollo/client';

import { CounterpartyBasicInfoFragment } from '../CounterpartyCard';

import { GetDealGeneralInfo } from './__generated__/dealDetailsQueries';

// Shared by every consumer of this query's `deal.listing.seller` selection -- centralized here,
// next to the query that produces it, instead of each consumer re-deriving an identical alias.
export type GetDealGeneralInfo_deal_listing_UserCompanyListing_seller = NonNullable<
  NonNullable<NonNullable<GetDealGeneralInfo>['deal']>['listing']
>['seller'];

export const GET_DEAL_GENERAL_INFO_QUERY = gql`
  query GetDealGeneralInfo($id: ID!) {
    deal(id: $id) {
      dealId: id
      is_chat_enabled
      role
      counterparty {
        ...CounterpartyBasicInfo
      }
      carvingEnabled
      createdDate: created_date
      listing {
        id
        assetClass: asset_class
        ...PoolHeaderListing
      }
      ...DealStagesDeal
      ...StatusTrackerDeal
    }
  }
  ${CounterpartyBasicInfoFragment.company}
  ${PoolHeaderFragments.listing}
  ${StatusTrackerFragments.deal}
  ${DealStagesFragments.Deal}
`;
